import { Button, FormControl, Paper, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useForm } from 'react-hook-form'
import FormField from '../../../common/form/FormField'
import { i18n } from '../../index/index'
import css from './marketSettingsPage.css'
import { ChainMarketSettingsInputForm } from './types'

interface Props {
  addChainMarketSettingsMutation: any
}

export function ChainMarketSettingsForm({ addChainMarketSettingsMutation }: Props) {
  const { control, handleSubmit, setError } = useForm<ChainMarketSettingsInputForm>({
    defaultValues: {
      value: '',
      name: 'MARKET_SALES_VOLUME_TARGET',
      year: '',
    },
  })

  const onSubmit = handleSubmit(async (data: ChainMarketSettingsInputForm, e) => {
    e?.preventDefault()
    const input = {
      value: data.value,
      name: data.name,
      startDate: moment(data.year).startOf('year').toISOString(),
      endDate: moment(data.year).endOf('year').toISOString(),
    }
    await addChainMarketSettingsMutation({ variables: { data: input } })
  })

  return (
    <Paper>
      <div>
        <Typography variant='h6'>{i18n.t('admin.marketSettings.addNewSalesVolumeTarget')}</Typography>
      </div>
      <form onSubmit={onSubmit}>
        <FormControl className={css.formFields}>
          <div className={css.inlineForm}>
            <FormField
              label={i18n.t('admin.marketSettings.target')}
              control={control}
              variant='outlined'
              name='value'
              type='number'
              rules={{ required: true }}
            />
            <FormField
              label={i18n.t('admin.marketSettings.year')}
              control={control}
              variant='outlined'
              name='year'
              type='number'
              rules={{ required: true }}
            />
            <div className={css.right}>
              <Button color='primary' variant='contained' type='submit' size='medium'>
                {i18n.t('buttons.save')}
              </Button>
            </div>
          </div>
        </FormControl>
      </form>
    </Paper>
  )
}
